module.exports = __webpack_public_path__ + "static/img/ADAM_ZAMPA.5fcacf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ADAM_ZAMPA.jpg
// module id = we2z
// module chunks = 0